import styles from "./summary.module.css";
import sharedStyles from "./checkout.module.css";
import { fmtCurrency } from "../../../../utils/functions";

export default function SummaryStep({
  product,
  productType,
  currency,
  onContinue,
  onBack,
}) {
  const isPack = productType === "topup";
  const { name, price, credits, creditsPerMonth, perCredit, features } =
    product;

  return (
    <div>
      <h2 className={styles.title}>Order summary</h2>
      <p className={styles.subtitle}>
        Review what you're getting before you pay.
      </p>

      <div className={styles.card}>
        <div className={styles.cardHead}>
          <span className={styles.cardIcon}>{isPack ? "🪙" : "📆"}</span>
          <div>
            <div className={styles.cardName}>
              {isPack ? `${name}` : `${name} Annual Plan`}
            </div>
            <div className={styles.cardSub}>
              {isPack
                ? "Credit Pack · one-time purchase"
                : "Annual Plan · pay once, access for 12 months"}
            </div>
          </div>
        </div>

        <div className={styles.featureList}>
          {features?.map((f) => (
            <div key={f} className={styles.featureRow}>
              <span className={styles.featureCheck}>✓</span>
              <span className={styles.featureText}>{f}</span>
            </div>
          ))}
        </div>

        <div className={styles.totals}>
          <div className={styles.totalsRow}>
            <span className={styles.totalsLbl}>
              {isPack
                ? `${credits} credits × ${fmtCurrency(perCredit, currency)}`
                : `${creditsPerMonth}C/mo × 12 months`}
            </span>
            <span className={styles.totalsVal}>
              {fmtCurrency(price, currency)}
            </span>
          </div>
          <div className={styles.totalsRow}>
            <span className={styles.grandLbl}>Total today</span>
            <span className={styles.grandVal}>
              {fmtCurrency(price, currency)}
            </span>
          </div>
          <div className={styles.totalsNote}>
            {isPack
              ? "One-time charge · credits never expire"
              : "One-time charge · renews in 12 months"}
          </div>
        </div>
      </div>

      <div className={styles.guarantee}>
        <span className={styles.guaranteeIcon}>🛡️</span>
        <div>
          <div className={styles.guaranteeTitle}>30-Day Rematch Guarantee</div>
          <div className={styles.guaranteeDesc}>
            If a hire leaves within 30 days, we'll rematch at 50% credit cost.
          </div>
        </div>
      </div>

      <button
        onClick={onContinue}
        className={sharedStyles.btnPrimary}
        style={{ marginBottom: 12 }}
      >
        Continue to your details →
      </button>
      <button onClick={onBack} className={sharedStyles.btnGhost}>
        ← Back to pricing
      </button>
    </div>
  );
}
